import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NGXLogger } from 'ngx-logger';
import { EMPTY, Observable, Subject, throwError } from 'rxjs';
import { catchError, debounceTime, finalize } from 'rxjs/operators';
import { AuthenticationService } from '../services/authentication-service.service';
import { ToastService } from '../services/toast.service';
import { ErrorHandlerService } from './../services/error-handler.service';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  uuid: any;
  private readonly sessionExpiredSubject = new Subject<void>();
  private readonly unknowErrorSubject = new Subject<void>();
  constructor(
    private readonly authenticationService: AuthenticationService,
    private readonly toastService: ToastService,
    private readonly translateService: TranslateService,
    private readonly errorHandlerService: ErrorHandlerService,
    private readonly logger: NGXLogger,
    private readonly route: Router,
  ) {
    // 只要在 debounceTime 內有 401，就只顯示一次 toast
    this.sessionExpiredSubject.pipe(debounceTime(500)).subscribe(() => {
      this.translateService.get("Common.Message.ConnectionTimeout").subscribe({
        next: (msg) => {
          this.toastService.error(msg);
        }
      });
    });
    // default case: debounce 顯示未知錯誤訊息
    this.unknowErrorSubject.pipe(debounceTime(500)).subscribe(() => {
      this.translateService.get('Common.Message.UnknowError').subscribe({
        next: (msg) => {
          this.toastService.error(msg);
        }
      });
    });
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((err: HttpErrorResponse) => {
        this.logger.error(err);
        switch (err.status) {
          case 401:
            this.authenticationService.logout();
            this.route.navigate([`/login`]);
            this.sessionExpiredSubject.next(); // 發送 401 訊息事件
            break;
          case 400:
            return throwError(err);
          case 422:
            return throwError(err);
          default:
            this.unknowErrorSubject.next();
            break;
        }

        return EMPTY;
      }),
      finalize(() => {})
    );
  }

  async storeErrorLog(err: HttpErrorResponse, req: HttpRequest<any>) {
    let project: string = '';
    if (err.url) {
      project = err.url.split('/')[3];
    }

    const request = {
      createUser: this.uuid,
      createDt: new Date(),
      updateUser: null,
      updateDt: null,
      httpStatus: JSON.stringify(err.status),
      requestBody: JSON.stringify(req.body),
      responseUrl: err.url,
      project: project,
      errorMessage: JSON.stringify(err.error),
      errorCode: err.error.errorCode,
      errorCodeCategory: err.error.category,
    };

    if (!err.url?.includes('storeErrorLog')) {
      this.errorHandlerService.storeErrorLog(request).subscribe();
    }
  }
}
